
Date.prototype.isValidDate = function(){
  return this instanceof Date && !isNaN(this);
}